import React , {Component} from 'react';

import './App.scss';

import MyRoute from './views/MyRouter';


class App extends Component
{
    render() {
        return (
            <MyRoute/>
        );
    }
}

export default App;
